import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './NewDiaryItem.module.css';
import { diaryActions, alertActions } from '_actions';
import { SaveButton, CancelButton, CheckBox, UserSearch } from '_components';

class PatientHomeDiaryNew extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            diaryNote: "",
            category: "select",
            urno: null
        };

        this.handleDiaryNoteChange = this.handleDiaryNoteChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.onUserSelected = this.onUserSelected.bind(this);
        this.save = this.save.bind(this);
    }

    handleDiaryNoteChange(event) {
        this.setState({ diaryNote: event.target.value });
    }

    handleCategoryChange(event) {
        this.setState({ category: event.target.value });
    }

    onUserSelected(urno) {
        this.setState({ urno: urno });
    }

    toggleIssue() {
        this.props.toggleIssue(this.props.ptno);
        this.setState({ urno: undefined });
    }

    save() {
        var msgs = [];
        if (!this.state.diaryNote)
            msgs = [...msgs, 'Diary Note'];
        if (this.state.category === 'select')
            msgs = [...msgs, 'Category'];
        if (this.props.isIssue && !this.state.urno)
            msgs = [...msgs, 'Assign To'];
        if (msgs.length > 0) {
            this.props.alertError('The following fields are required: ' + msgs.join(', '));
        } else {
            this.props.saveDiary(this.props.ptno, this.state.diaryNote, parseInt(this.state.category), this.state.urno);
        }
    }

    render() {
        return (
            <div className={styles.panel_wrapper}>
                <div className={styles.left_wrapper}>
                    <div className={styles.header}>New Diary Note</div>
                    <textarea autoFocus name="diaryNote" type="text" className={styles.diary} rows="5" value={this.state.diaryNote} onChange={this.handleDiaryNoteChange} />
                </div>
                <div className={styles.right_wrapper}>
                    <div className={styles.category_wrapper}>
                        <span className={styles.category_label}>Category</span>
                        <select className={styles.category_dropdown} defaultValue="select" onChange={this.handleCategoryChange}>
                            <option key={-1} value="select" disabled>Select a category...</option>

                            {Object.keys(this.props.categories)
                                .map(id => {
                                    const cat = this.props.categories[id];
                                    return (
                                        <option key={cat.DCNO} value={cat.DCNO}>{cat.DCDESC}</option>
                                    );
                                })
                            }
                        </select>
                    </div>
                    <div className={styles.issue_wrapper}>
                        <CheckBox
                            size='extra-small'
                            checked={this.props.isIssue}
                            label='Issue to Resolve'
                            onClick={() => {this.toggleIssue()}}
                        />
                    </div>
                    <div style={{ height: 29 }}>
                        {this.props.isIssue &&
                            <div className={styles.assign_to_wrapper}>
                                <span className={styles.assign_to_label}>Assign To</span>
                                <span className={styles.assign_to}>
                                    <UserSearch onSelected={this.onUserSelected} />
                                </span>
                            </div>
                        }
                    </div>
                    <div className={styles.buttons_wrapper}>
                        <span style={{ paddingRight: '5px' }}><SaveButton onClick={() => this.save()} /></span>
                        <span><CancelButton onClick={() => this.props.hideDiary(this.props.ptno)} /></span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        entry: state.entities.diary[ownprops.id],
        ptno: state.ui.patients.selectedPtno,
        isIssue: state.ui.diary[state.ui.patients.selectedPtno].isIssue,
        categories: Object.keys(state.entities.masterData.FNDIARYCATEGORY)
            .sort((a, b) => state.entities.masterData.FNDIARYCATEGORY[b].DCDESC > state.entities.masterData.FNDIARYCATEGORY[a].DCDESC ? -1 : 1)
            .map(key => state.entities.masterData.FNDIARYCATEGORY[key]),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        hideDiary: bindActionCreators(diaryActions.hideDiary, dispatch),
        saveDiary: bindActionCreators(diaryActions.saveDiary, dispatch),
        toggleIssue: bindActionCreators(diaryActions.toggleIssue, dispatch),
        alertError: bindActionCreators(alertActions.error, dispatch)
    };
}

const connectedPatientHomeDiaryNew = connect(mapStateToProps, mapDispatchToProps)(PatientHomeDiaryNew);
export { connectedPatientHomeDiaryNew as PatientHomeDiaryNew };